import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent {
  orgForm!: FormGroup;
  contractorsForm!: FormGroup;
  indianSpecificForm!: FormGroup;
  documentationForm!: FormGroup;
  vendorForm!: FormGroup;
  machineType: any;
  errorMessage1: any

  submitted = false;
  imageurl: any;
  file: any;
  options = [
    { id: 1, name: 'JCB' },
    { id: 2, name: 'Truck' },
    { id: 3, name: 'Engine' }
  ];
  userId: any
  organizationId: any;
  branchList:any
  userD:any
  branchShow= true

  /** Seat-budget snapshot for the current org (from /subscription/seat-budget). */
  seatBudget: {
    hasSubscription: boolean;
    cap: number;
    consumed: number;
    remaining: number;
    limitExceeded: boolean;
    message: string;
  } | null = null;
  seatBudgetLoading = false;

  constructor(
    private formBuilder: FormBuilder,
    private readonly apiService: ApiService,
    private router: Router,
    private readonly toastrMsgService: ToastrMsgService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {

    this.route.params.subscribe((params) => {
      this.userId = params['id'];
    });
    const user = localStorage.getItem('user') as any;
    this.userD = JSON.parse(user);
    this.organizationId=this.userD.user.org_id;
    this.fetchBranchList()
    this.loadSeatBudget();
    this.vendorForm = this.formBuilder.group({
      branch_id: [+this.organizationId, Validators.required],
      userType: ['', Validators.required],
      vendorName: ['', Validators.required],
      fullName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      industryType: ['', Validators.required],
      primaryPhone: ['', Validators.required],
      alternativePhone: ['', Validators.required],
      website: ['', Validators.required]
    });


    this.contractorsForm = this.formBuilder.group({
      mainContractorName: ['', Validators.required],
      mainContractorLicense: ['', Validators.required],
      mainContractorCategory: ['', Validators.required],
      mainContractorContact: ['', Validators.required],
      performanceHistory: [''],
      bankGuarantee: [''],

      subcontractScope: [''],
      subcontractCompany: [''],
      subcontractContact: [''],

      materialType: ['', Validators.required],
      supplierName: ['', Validators.required],
      qualityCertifications: [''],
      supplierContact: [''],

      quarryLocations: [''],
      borrowDetails: [''],
      royaltyStatus: ['']
    });

    this.indianSpecificForm = this.formBuilder.group({
      gstDetails: ['', Validators.required],
      taxDeduction: [''],
      labourLicense: [''],
      workmenInsurance: [''],
      pfEsi: [''],
      labourWelfare: [''],
      contractType: ['', Validators.required],
      arbitration: [''],
      conciliation: [''],
      disputeBoard: [''],
      makeInIndia: [''],
      msmeParticipation: [''],
      defectLiability: [''],
      routineMaintenance: [''],
      performanceMaintenance: ['']
    });

    this.documentationForm= this.formBuilder.group({
      contractDocs: ['', Validators.required],
      dpr: ['', Validators.required],
      gfcDrawings: [''],
      progressReports: [''],
      qap: [''],
      testReports: [''],
      asBuiltDrawings: [''],
      omManuals: ['']
    });
    if (this.userId) {
      this.getUserDetails(this.userId);
    }
  }

  /**
   * Load the seat-budget snapshot. Skipped while editing (userId set) so
   * the banner doesn't claim the cap is reached when we're just editing
   * a row that already counts against the cap.
   */
  loadSeatBudget(): void {
    if (this.userId) return;
    this.seatBudgetLoading = true;
    this.apiService.getSeatBudget().subscribe({
      next: (res: any) => {
        this.seatBudgetLoading = false;
        this.seatBudget = res?.data || null;
      },
      error: () => {
        this.seatBudgetLoading = false;
        this.seatBudget = null;
      },
    });
  }

  get seatLimitReached(): boolean {
    return !!this.seatBudget?.limitExceeded;
  }

  fetchBranchList() {
    this.apiService.getOrganizationsBranch( this.organizationId).subscribe({
      next: (res: any) => {
        console.log('API Response:', res);
        if(res.data.length != 0){

          this.branchList=res.data
        }else{

          this.branchShow=false

        }
        
       
      },
      error: (err) => {
        console.log('API Error:', err);
        this.toastrMsgService.error(err.error.message);
      },
      complete: () => console.log('Observable complete'),
    });
  }




  handleFileInput(event: any) {
    this.file = event.target.files[0];
    const fileSize = this.file.size / 1024 / 1024; // Convert bytes to KB
    const fileType = this.file.type;

    if (!this.file) {
      // this.errorMessage1 = 'No file chosen.';
      return;
    }

    if (fileType !== 'image/jpeg' && fileType !== 'image/png') {
      this.errorMessage1 = 'File should be JPEG or PNG.';
      return;
    }

    if (fileSize > 3) {
      this.errorMessage1 = 'File size should be less than 3 MB.';
      return;
    }

    this.imageurl = URL.createObjectURL(this.file);

  }

  onSubmit(): void {
    if (this.userId) {
      this.update(this.userId);
    } else {
      if (this.seatLimitReached) {
        this.toastrMsgService.error(
          this.seatBudget?.message ||
            'Subscription seat limit reached. Please upgrade to add more users.'
        );
        return;
      }
      if (this.vendorForm.invalid) {
        this.vendorForm.markAllAsTouched();
        return;
      }

      const userFrom = {
        branch_id: this.vendorForm.value.branch_id || this.organizationId,
        userType: this.vendorForm.value.userType || '', // Ensures '' if null/undefined
        vendorName: this.vendorForm.value.vendorName || '',
        fullName: this.vendorForm.value.fullName || '',
        email: this.vendorForm.value.email || '',
        password: this.vendorForm.value.password || '',
        industryType: this.vendorForm.value.industryType || '',
        primaryPhone: this.vendorForm.value.primaryPhone || '',
        alternativePhone: this.vendorForm.value.alternativePhone || '',
        website: this.vendorForm.value.website || '',
        mainContractorName: this.contractorsForm.value.mainContractorName || '',
        mainContractorLicense: this.contractorsForm.value.mainContractorLicense || '',
        mainContractorCategory: this.contractorsForm.value.mainContractorCategory || '',
        mainContractorContact: this.contractorsForm.value.mainContractorContact || '',
        performanceHistory: this.contractorsForm.value.performanceHistory || '',
        bankGuarantee: this.contractorsForm.value.bankGuarantee || '',
        subcontractScope: this.contractorsForm.value.subcontractScope || '',
        subcontractCompany: this.contractorsForm.value.subcontractCompany || '',
        subcontractContact: this.contractorsForm.value.subcontractContact || '',
        materialType: this.contractorsForm.value.materialType || '',
        supplierName: this.contractorsForm.value.supplierName || '',
        qualityCertifications: this.contractorsForm.value.qualityCertifications || '',
        supplierContact: this.contractorsForm.value.supplierContact || '',
        quarryLocations: this.contractorsForm.value.quarryLocations || '',
        borrowDetails: this.contractorsForm.value.borrowDetails || '',
        royaltyStatus: this.contractorsForm.value.royaltyStatus || '',
        gstDetails: this.indianSpecificForm.value.gstDetails || '',
        taxDeduction: this.indianSpecificForm.value.taxDeduction || '',
        labourLicense: this.indianSpecificForm.value.labourLicense || '',
        workmenInsurance: this.indianSpecificForm.value.workmenInsurance || '',
        pfEsi: this.indianSpecificForm.value.pfEsi || '',
        labourWelfare: this.indianSpecificForm.value.labourWelfare || '',
        contractType: this.indianSpecificForm.value.contractType || '',
        arbitration: this.indianSpecificForm.value.arbitration || '',
        conciliation: this.indianSpecificForm.value.conciliation || '',
        disputeBoard: this.indianSpecificForm.value.disputeBoard || '',
        makeInIndia: this.indianSpecificForm.value.makeInIndia || '',
        msmeParticipation: this.indianSpecificForm.value.msmeParticipation || '',
        defectLiability: this.indianSpecificForm.value.defectLiability || '',
        routineMaintenance: this.indianSpecificForm.value.routineMaintenance || '',
        performanceMaintenance: this.indianSpecificForm.value.performanceMaintenance || '',
        contractDocs: this.documentationForm.value.contractDocs || '',
        dpr: this.documentationForm.value.dpr || '',
        gfcDrawings: this.documentationForm.value.gfcDrawings || '',
        progressReports: this.documentationForm.value.progressReports || '',
        qap: this.documentationForm.value.qap || '',
        testReports: this.documentationForm.value.testReports || '',
        asBuiltDrawings: this.documentationForm.value.asBuiltDrawings || '',
        omManuals: this.documentationForm.value.omManuals || '',
      };


      this.apiService.addUser(userFrom).subscribe({
        next: (res: any) => {
          this.toastrMsgService.success('User created successfully');
          if (res?.seatBudget) {
            this.seatBudget = {
              hasSubscription: res.seatBudget.hasSubscription,
              cap: res.seatBudget.cap,
              consumed: res.seatBudget.consumed,
              remaining: Math.max(0, res.seatBudget.cap - res.seatBudget.consumed),
              limitExceeded: res.seatBudget.limitExceeded,
              message: res.seatBudget.message,
            };
          }
          this.router.navigate(['home/user'])
        },
        error: (err) => {
          console.log(err);
          if (err?.status === 403 && err?.error?.code === 'SEAT_LIMIT_REACHED') {
            this.seatBudget = err.error.seatBudget
              ? {
                  hasSubscription: err.error.seatBudget.hasSubscription,
                  cap: err.error.seatBudget.cap,
                  consumed: err.error.seatBudget.consumed,
                  remaining: Math.max(0, err.error.seatBudget.cap - err.error.seatBudget.consumed),
                  limitExceeded: true,
                  message: err.error.seatBudget.message,
                }
              : this.seatBudget;
            this.toastrMsgService.error(
              err.error.error ||
                'Subscription seat limit reached. Please upgrade to add more users.'
            );
            return;
          }
          this.toastrMsgService.error(
            err?.error?.errorMessage || err?.error?.error || 'Failed to create user'
          );
        },
        complete: () => console.log('Observable complete'),
      });
    }
  }
  getUserDetails(id: any) {
    this.apiService.getUserById(id).subscribe({
      next: (res: any) => {
        const data = res;
        this.vendorForm.get('password')?.clearValidators();
        this.vendorForm.get('password')?.updateValueAndValidity();
        this.vendorForm.patchValue({
          branch_id: data.branch_id,
          userType: data.user_type,
          vendorName: data.vendor_name,
          fullName: data.full_name,
          email: data.email,
          industryType: data.industry_type,
          primaryPhone: data.primary_phone,
          alternativePhone: data.alternative_phone,
          website: data.website
        });

        this.contractorsForm.patchValue({
          mainContractorName: data.main_contractor_name,
          mainContractorLicense: data.main_contractor_license,
          mainContractorCategory: data.main_contractor_category,
          mainContractorContact: data.main_contractor_contact,
          performanceHistory: data.performance_history,
          bankGuarantee: data.bank_guarantee,
          subcontractScope: data.subcontract_scope,
          subcontractCompany: data.subcontract_company,
          subcontractContact: data.subcontract_contact,
          materialType: data.material_type,
          supplierName: data.supplier_name,
          qualityCertifications: data.quality_certifications,
          supplierContact: data.subcontract_contact,
          quarryLocations: data.supplier_contact,
          borrowDetails: data.borrow_details,
          royaltyStatus: data.royalty_status
        });

        this.indianSpecificForm.patchValue({
          gstDetails: data.gst_details,
          taxDeduction: data.tax_deduction,
          labourLicense: data.labour_license,
          workmenInsurance: data.workmen_insurance,
          pfEsi: data.pf_esi,
          labourWelfare: data.labour_welfare,
          contractType: data.contract_type,
          arbitration: data.arbitration,
          conciliation: data.conciliation,
          disputeBoard: data.dispute_board,
          makeInIndia: data.make_in_india,
          msmeParticipation: data.msme_participation,
          defectLiability: data.defect_liability,
          routineMaintenance: data.routine_maintenance,
          performanceMaintenance: data.performance_maintenance
        });

        this.documentationForm.patchValue({
          contractDocs: data.contract_docs,
          dpr: data.dpr,
          gfcDrawings: data.gfc_drawings,
          progressReports: data.progress_reports,
          qap: data.qap,
          testReports: data.test_reports,
          asBuiltDrawings: data.as_built_drawings,
          omManuals: data.om_manuals
        });
console.log( this.documentationForm.value)

      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      }
    });


  }

  update(id: any): void {
    if (this.vendorForm.invalid) {
      this.vendorForm.markAllAsTouched();
      return;
    }

    const userFrom = {
      branch_id: this.vendorForm.value.branch_id || '', // Ensures '' if null/undefined
      userType: this.vendorForm.value.userType || '', // Ensures '' if null/undefined
      vendorName: this.vendorForm.value.vendorName || '',
      fullName: this.vendorForm.value.fullName || '',
      email: this.vendorForm.value.email || '',
      password: this.vendorForm.value.password || '',
      industryType: this.vendorForm.value.industryType || '',
      primaryPhone: this.vendorForm.value.primaryPhone || '',
      alternativePhone: this.vendorForm.value.alternativePhone || '',
      website: this.vendorForm.value.website || '',
      mainContractorName: this.contractorsForm.value.mainContractorName || '',
      mainContractorLicense: this.contractorsForm.value.mainContractorLicense || '',
      mainContractorCategory: this.contractorsForm.value.mainContractorCategory || '',
      mainContractorContact: this.contractorsForm.value.mainContractorContact || '',
      performanceHistory: this.contractorsForm.value.performanceHistory || '',
      bankGuarantee: this.contractorsForm.value.bankGuarantee || '',
      subcontractScope: this.contractorsForm.value.subcontractScope || '',
      subcontractCompany: this.contractorsForm.value.subcontractCompany || '',
      subcontractContact: this.contractorsForm.value.subcontractContact || '',
      materialType: this.contractorsForm.value.materialType || '',
      supplierName: this.contractorsForm.value.supplierName || '',
      qualityCertifications: this.contractorsForm.value.qualityCertifications || '',
      supplierContact: this.contractorsForm.value.supplierContact || '',
      quarryLocations: this.contractorsForm.value.quarryLocations || '',
      borrowDetails: this.contractorsForm.value.borrowDetails || '',
      royaltyStatus: this.contractorsForm.value.royaltyStatus || '',
      gstDetails: this.indianSpecificForm.value.gstDetails || '',
      taxDeduction: this.indianSpecificForm.value.taxDeduction || '',
      labourLicense: this.indianSpecificForm.value.labourLicense || '',
      workmenInsurance: this.indianSpecificForm.value.workmenInsurance || '',
      pfEsi: this.indianSpecificForm.value.pfEsi || '',
      labourWelfare: this.indianSpecificForm.value.labourWelfare || '',
      contractType: this.indianSpecificForm.value.contractType || '',
      arbitration: this.indianSpecificForm.value.arbitration || '',
      conciliation: this.indianSpecificForm.value.conciliation || '',
      disputeBoard: this.indianSpecificForm.value.disputeBoard || '',
      makeInIndia: this.indianSpecificForm.value.makeInIndia || '',
      msmeParticipation: this.indianSpecificForm.value.msmeParticipation || '',
      defectLiability: this.indianSpecificForm.value.defectLiability || '',
      routineMaintenance: this.indianSpecificForm.value.routineMaintenance || '',
      performanceMaintenance: this.indianSpecificForm.value.performanceMaintenance || '',
      contractDocs: this.documentationForm.value.contractDocs || '',
      dpr: this.documentationForm.value.dpr || '',
      gfcDrawings: this.documentationForm.value.gfcDrawings || '',
      progressReports: this.documentationForm.value.progressReports || '',
      qap: this.documentationForm.value.qap || '',
      testReports: this.documentationForm.value.testReports || '',
      asBuiltDrawings: this.documentationForm.value.asBuiltDrawings || '',
      omManuals: this.documentationForm.value.omManuals || '',
    };


    this.apiService.updateUser(id, userFrom).subscribe({
      next: (res) => {
        this.toastrMsgService.success('User Updated successfully');
        this.router.navigate(['home/user'])
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
  }

  // uploadContractDocs(event: Event): void {
  //   const file = (event.target as HTMLInputElement).files?.[0];

  //   if (file) {
  //     this.apiService.uploadContractDocs(file, 'docs').subscribe({
  //       next: (res: any) => {
  //         this.documentationForm.patchValue({
  //           contractDocs: res?.docs,
  //         });
  //         this.toastrMsgService.success('Contract Docs uploaded successfully');
  //       },
  //       error: err => {
  //         console.error('Contract Docs upload failed:', err);
  //       }
  //     });
  //   }
  // }

  uploadContractDocs(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];

    if (file) {
      this.apiService.uploadContractDocs(file, 'docs').subscribe({
        next: (res: any) => {
          this.documentationForm.patchValue({
            contractDocs: res?.docs,
          });
          this.documentationForm.get('contractDocs')?.updateValueAndValidity();
          this.toastrMsgService.success('Contract Docs uploaded successfully');
        },
        error: err => {
          console.error('Contract Docs upload failed:', err);
        }
      });
    }
  }


  // uploadDPR(event: Event) {
  //   const file = (event.target as HTMLInputElement).files?.[0];
  //   if (file) {
  //     this.apiService.uploadContractDocs(file, 'dpr')?.subscribe({
  //       next: (res: any) => {
  //         this.documentationForm.patchValue({
  //           dpr: res?.dpr,
  //         });
  //         this.toastrMsgService.success('Contract Docs uploaded successfully');
  //       },
  //       error: err => console.error('DPR upload failed', err)
  //     });
  //   }
  // }
  uploadDPR(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      this.apiService.uploadContractDocs(file, 'dpr')?.subscribe({
        next: (res: any) => {
          this.documentationForm.patchValue({
            dpr: res?.dpr,
          });
          this.documentationForm.get('dpr')?.updateValueAndValidity();
          this.toastrMsgService.success('Contract Docs uploaded successfully');
        },
        error: err => console.error('DPR upload failed', err)
      });
    }
  }




  uploadGFCDrawings(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file)
      this.apiService.uploadContractDocs(file, 'drawings')?.subscribe({
        next: (res: any) => {
          this.documentationForm.patchValue({
            gfcDrawings: res?.drawings,
          });
          this.toastrMsgService.success('Contract Docs uploaded successfully');
        },
        error: err => console.error('DPR upload failed', err)
      });
  }

  uploadProgressReports(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) this.apiService.uploadContractDocs(file, 'reports')?.subscribe({

      next: (res: any) => {
        this.documentationForm.patchValue({
          progressReports: res?.reports,
        });
        this.toastrMsgService.success('Contract Docs uploaded successfully');
      },
      error: err => console.error('DPR upload failed', err)
    });
  }

  uploadQAP(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) this.apiService.uploadContractDocs(file, 'qap')?.subscribe({
      next: (res: any) => {
        this.documentationForm.patchValue({
          qap: res?.qap,
        });
        this.toastrMsgService.success('Contract Docs uploaded successfully');
      },
      error: err => console.error('DPR upload failed', err)
    });
  }

  uploadTestReports(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file)
      this.apiService.uploadContractDocs(file, 'testReports')?.subscribe({
        next: (res: any) => {
          this.documentationForm.patchValue({
            testReports: res?.testReports,
          });
          this.toastrMsgService.success('Contract Docs uploaded successfully');
        },
        error: err => console.error('DPR upload failed', err)
      });
  }

  uploadAsBuiltDrawings(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) this.apiService.uploadContractDocs(file, 'asBuiltDrawings')?.subscribe({
      next: (res: any) => {
        this.documentationForm.patchValue({
          asBuiltDrawings: res?.asBuiltDrawings,
        });
        this.toastrMsgService.success('Contract Docs uploaded successfully');
      },
      error: err => console.error('DPR upload failed', err)
    });
  }

  uploadOMManuals(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file)
      this.apiService.uploadContractDocs(file, 'Manuals')?.subscribe({
        next: (res: any) => {
          this.documentationForm.patchValue({
            omManuals: res?.Manuals,
          });
          this.toastrMsgService.success('Contract Docs uploaded successfully');
        },
        error: err => console.error('DPR upload failed', err)
      });
  }

}



